import { Typography, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import React from 'react'
import i18n from 'i18next'
import moment from 'moment'

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails)

const AccordionModel = ({ current }) => {
  const [expanded, setExpanded] = React.useState('0')

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <Accordion square expanded={expanded === `${current.id}`} onChange={handleChange(`${current.id}`)}>
      <AccordionSummary aria-controls="panel1d-content" id={current.id}>
        <Grid container justifyContent="space-between">
          <Typography>
            {`${current.structure}`}
            <br />
            <small>{`${current.role}`}</small>
          </Typography>
          <Grid item>
            <Typography display="inline">
              {i18n.t('profile.background.labels.de')} {moment(current.from).format('MMM YYYY')}
            </Typography>
            {current.to ? (
              <Typography display="inline">
                {' '}
                {i18n.t('profile.background.labels.a')} {moment(current.to).format('MMM YYYY')}
              </Typography>
            ) : (
              i18n.t('profile.background.labels.today')
            )}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          {i18n.t('profile.background.labels.description')} {current.description}
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}
export default AccordionModel
